import React, { useCallback, useEffect, useState } from "react";

// Styles
import styles from "./overallProgress.module.scss";

// Components
import Spinner from "../../components/spinner";
import Streak from "../../components/Streak";
import Level from "./Level";
import Lives from "./Lives";
import Topics from "../Topics";

// Utils
import { coursesTotalProgressUrl, courseProgressUrl } from "../../utils/urls";

const OverallProgress = ({ isShow = false, courseId }) => {
  const [experience, setExperience] = useState({ level: 0, current: 0, total: 0 });
  const [lives, setLives] = useState({ current: 0, timeUntilNext: 0 });
  const [streak, setStreak] = useState(0);
  const [topics, setTopics] = useState({ current: 0, total: 0 });

  // Flags
  const [loading, setLoading] = useState(true);

  const loadOverallProgress = useCallback(async () => {
    try {
      const options = { method: "GET", headers: { "Accept": "application/json" } };

      setLoading(true)
      const url = courseId ? courseProgressUrl(courseId) : coursesTotalProgressUrl();
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setExperience({
          level: data.current_level,
          current: data.current_exp,
          total: data.total_exp
        });
        setLives({
          current: data.current_lives,
          total: data.current_lives,
          timeUntilNext: data.next_life_seconds
        });
        setStreak(data.streak);
        setTopics({
          current: data.topic_count,
          total: data.total_topics
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Effects
  useEffect(() => {
    loadOverallProgress();
  }, [loadOverallProgress]);

  return (
    <div className={`${styles.container} ${isShow && styles.show}`}>
      {loading && <Spinner />}

      <Level level={experience.level} currentExp={experience.current} totalExp={experience.total} />

      {/* TODO: Add lives, we're removing them for now because it does not make sense for someone studying on their own */}
      {/* {isShow && <Lives lives={lives} />} */}

      <div className={styles.streaksTopics}>
        <Streak streak={streak} type={isShow ? 'show' : 'default'} />

        {/* <Topics topics={topics} isShow={isShow} /> */}
      </div>
    </div>
  )
}

export default OverallProgress;
